import React, { useState, useEffect, useCallback } from 'react';
import './style.css';  // Make sure to add the CSS
import Header from '../Header';
import Footer from '../Footer';

export default function Client() {

 
    // State to track if the user is attempting to leave the exam page
    const [isSuspicious, setIsSuspicious] = useState(false);
  
    // Function to handle mouse movement
    const handleMouseMove = (event: MouseEvent) => {
      const x = event.clientX;
      const y = event.clientY;
  
      // Check if the mouse is near the edges of the window (top, left, right, or bottom)
      if (x <= 10 || y <= 10 || x >= window.innerWidth - 10 || y >= window.innerHeight - 10) {
        // If the mouse is near the edges, it might be an indicator that the user is trying to leave the page
        setIsSuspicious(true);
      } else {
        setIsSuspicious(false);
      }
    };
  
    // Add event listener for mouse move
    useEffect(() => {
      document.addEventListener('mousemove', handleMouseMove);
  
      // Clean up the event listener when the component is unmounted
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
      };
    }, []);

   // Array of image sources
   const images = [
    require('../../Images/Client1.jpg'),
    require('../../Images/Client2.jpg'),
    require('../../Images/Client3.jpg'),
    require('../../Images/Client4.jpg'),
    require('../../Images/Client5.jpg'),
    require('../../Images/Client6.jpg'),
    require('../../Images/Client7.jpg'),
    require('../../Images/Client9.jpg'),
    require('../../Images/Client10.jpg'),
  ];
  const [counter, setCounter] = useState(0); // Initial counter value for the countdown
  const [isCounting, setIsCounting] = useState(false); // Whether the countdown has started
  const [isBlurred, setIsBlurred] = useState(false); // Whether the page is blurred

  // Start the countdown and apply blur after the alert is acknowledged
  const startTimer = () => {
    setCounter(10);  // Set the counter to 10 seconds
    setIsCounting(true);  // Start the countdown
    setIsBlurred(true);  // Apply blur effect to the page
  };

  // Timer effect (counts down every second)
  useEffect(() => {
    let timer;
    if (isCounting && counter > 0) {
      timer = setInterval(() => {
        setCounter(prevCounter => prevCounter - 1);
      }, 1000);
    } else if (counter === 0) {
      setIsCounting(false); // Stop the timer once it reaches 0
      setIsBlurred(false);  // Remove the blur effect after 10 seconds
    }

    return () => clearInterval(timer); // Cleanup interval
  }, [counter, isCounting]);

  // Handle tab focus/blur (trigger alert when the user switches tabs or window)
  const handleFocusChange = useCallback((e) => {
    if (e.type === 'blur') {
      // Show the alert when the tab loses focus
      alert('Please stay on the exam screen!');
      setTimeout(() => {
        // Start the timer after the alert is dismissed
        startTimer();
      }, 0); // Start the timer immediately after the alert dismisses
    }
  }, []);

  useEffect(() => {
   
    window.addEventListener('focus', handleFocusChange);
    window.addEventListener('blur', handleFocusChange);

    return () => {
      window.removeEventListener('focus', handleFocusChange);
      window.removeEventListener('blur', handleFocusChange);
    };
  }, [handleFocusChange]);

  return (
    <div>
      <Header />
      {isSuspicious && (
        <div style={{ position: 'absolute', top: '10px', left: '50%', transform: 'translateX(-50%)', color: 'gray', padding: '10px', fontSize: '16px',border:"1px solid red" }}>
          <strong>Warning: You're trying to leave the exam window!</strong>
        </div>
      )}
      <h2 className="client-heading">Our Clients</h2>

      <div className="gallery-container">
        {images.map((src, index) => (
          <div key={index} className="gallery-item">
         <img src={src} alt={`Client ${index + 1}`} className="gallery-image" />

          </div>
        ))}
      </div>

      <div className="gallery-container">
        {/* Add your images here */}
      </div>

      {/* Show the countdown timer after the user clicks OK on the alert */}
      {isCounting && (
        <div className="timer-container">
          <div className="circle">
            <span>{counter}</span>
          </div>
        </div>
      )}

      {/* Apply the blur effect */}
      {isBlurred && <div className="blur-overlay"></div>}

      <Footer />
    </div>
  );
}
